<section class="m-lg !p-lg relative overflow-y-auto bg-white" hlmCard>
  @if (referentielLivrableStore.loading()) {
    <app-spinner />
  }
  <div hlmCardHeader>
    <h3 hlmCardTitle>Suivi des livrables</h3>
    @if (nbFiltres()) {
      <div class="gap-xs flex" hlmCardDescription>
        @if (filtres(); as filtres) {
          @if (filtres.cartographies?.length) {
            <app-chip-filtre
              [items]="cartographies()"
              [selectedItems]="filtres.cartographies ?? []"
              (onChange)="updateCartographies($event)"
              type="Cartographies"
              multiple
            />
          }
          @if (filtres.services?.length) {
            <app-chip-filtre
              [items]="referentielTypes"
              [selectedItems]="filtres.services ?? []"
              (onChange)="updateServices($event)"
              type="Services"
              multiple
            />
          }
          @if (filtres.institutsMetiers?.length) {
            <app-chip-filtre
              [items]="institutsMetier"
              [selectedItems]="filtres.institutsMetiers ?? []"
              (onChange)="updateInstitutsMetiers($event)"
              showSearchbar
              type="Instituts"
              multiple
            />
          }
          @if (filtres.livrables?.length) {
            <app-chip-filtre
              [items]="typesLivrable"
              [selectedItems]="filtres.livrables ?? []"
              (onChange)="updateLivrables($event)"
              type="Livrables"
              multiple
            />
          }
          @if (filtres.statuts?.length) {
            <app-chip-filtre
              [items]="statuts"
              [selectedItems]="filtres.statuts ?? []"
              [sortKey]="null"
              (onChange)="updateStatuts($event)"
              type="Statuts"
              multiple
            />
          }
          @if (filtres.echeance; as selectedEcheance) {
            <app-chip-filtre
              [items]="echeances"
              [selectedItems]="selectedEcheance"
              (onChange)="updateEcheance($event)"
              type="Échéance"
            />
          }
        }
      </div>
    }
    <div hlmCardAction>
      <button [appBadge]="nbFiltres()" (click)="ouvrirFiltres()" size="xxl" hlmBtn variant="secondary">
        <ng-icon hlm name="lucideListFilter" size="sm" />
      </button>
    </div>
  </div>
  <div class="!p-0" hlmCardContent>
    <div class="overflow-x-auto" hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th class="w-1/5" hlmTh>Cartographie</th>
            <th class="w-1/5" hlmTh>Service</th>
            <th class="w-1/5" hlmTh>Livrables</th>
            <th hlmTh>Échéance</th>
            <th class="w-[230px]" hlmTh>Statut</th>
            <th class="w-[210px]" hlmTh>État</th>
            <th class="w-[130px]" hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (livrable of livrables(); track $index) {
            <tr tabindex="0" hlmTr>
              <td hlmTd>{{ livrable.cartographie.nom }}</td>
              <td hlmTd>
                <div class="flex flex-col">
                  <span class="component-small-medium text-content-secondary">{{
                    livrable.referentiel.referentielType
                  }}</span>
                  <span>{{ livrable.referentiel.nom }}</span>
                </div>
              </td>
              <td hlmTd>
                <div class="flex flex-col">
                  @if (livrable.nomLivrableParent) {
                    <span class="component-small-medium text-content-secondary">{{ livrable.nomLivrableParent }}</span>
                  }
                  <span>
                    @if (getTypeLivrable(livrable) === 'Parcours & Croisement' && !livrable.idParcours) {
                      Croisement
                    } @else {
                      {{ livrable.nomParcours ?? livrable.nomLivrable }}
                    }
                  </span>
                </div>
              </td>
              <td hlmTd>{{ livrable.dateEcheance | date: 'dd MMM yyyy' }}</td>
              <td hlmTd>
                <app-etat-referentiel-livrable
                  [etat]="livrable.etat"
                  [peutModifier]="peutModifier(livrable.referentiel.equipeResponsable, livrable, [roles.AVANCEMENT])"
                  (etatChange)="onChangeEtat(livrable.id, $event)"
                />
              </td>
              <td hlmTd>
                <app-etat-verrouillage
                  [estVerrouille]="livrable.estVerrouille !== undefined ? livrable.estVerrouille : datePassee(livrable)"
                />
              </td>
              <td hlmTd>
                @if (livrable.idParcours) {
                  <button (click)="redirect(livrable, 'parcours')" hlmBtn variant="ghost" size="xxl">
                    @if (peutModifier(livrable.referentiel.equipeResponsable, livrable, [roles.PARCOURS])) {
                      <ng-icon name="lucideArrowRight" />
                    } @else {
                      <ng-icon name="lucideEye" />
                    }
                  </button>
                } @else if (getTypeLivrable(livrable) === 'Parcours & Croisement') {
                  <button (click)="redirect(livrable, 'croisement')" hlmBtn variant="ghost" size="xxl">
                    @if (peutModifier(livrable.referentiel.equipeResponsable, livrable, [roles.PARCOURS])) {
                      <ng-icon name="lucideArrowRight" />
                    } @else {
                      <ng-icon name="lucideEye" />
                    }
                  </button>
                } @else if (getTypeLivrable(livrable) === 'Modularisation') {
                  <button (click)="redirect(livrable, 'parcours', { niveau: '02' })" hlmBtn variant="ghost" size="xxl">
                    @if (peutModifier(livrable.referentiel.equipeResponsable, livrable, [roles.MODULARISATION])) {
                      <ng-icon name="lucideArrowRight" />
                    } @else {
                      <ng-icon name="lucideEye" />
                    }
                  </button>
                } @else if (getTypeLivrable(livrable) === 'Scénarisation') {
                  <button (click)="redirect(livrable, 'parcours', { niveau: '02' })" hlmBtn variant="ghost" size="xxl">
                    @if (peutModifier(livrable.referentiel.equipeResponsable, livrable, [roles.SCENARISATION])) {
                      <ng-icon name="lucideArrowRight" />
                    } @else {
                      <ng-icon name="lucideEye" />
                    }
                  </button>
                } @else {
                  <button (click)="redirect(livrable)" hlmBtn variant="ghost" size="xxl">
                    @if (peutModifier(livrable.referentiel.equipeResponsable, livrable, [roles.REFERENTIEL])) {
                      <ng-icon name="lucideArrowRight" />
                    } @else {
                      <ng-icon name="lucideEye" />
                    }
                  </button>
                }
                @if (nodeContextMenuItems(livrable.id).length > 0) {
                  <button
                    [hlmDropdownMenuTrigger]="actionsMenu"
                    [hlmDropdownMenuTriggerData]="{
                      $implicit: { id: livrable.id },
                    }"
                    hlmBtn
                    variant="ghost"
                    size="xxl"
                  >
                    <ng-icon name="lucideEllipsisVertical" />
                  </button>
                }
              </td>
            </tr>
          } @empty {
            <tr hlmTr>
              <td hlmTd colspan="7">Aucun référentiel ne correspond à votre recherche</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <app-paginateur [store]="referentielLivrableStore" />
  </div>
</section>

<ng-template #actionsMenu let-ctx>
  <hlm-dropdown-menu>
    <hlm-dropdown-menu-group>
      @for (item of nodeContextMenuItems(ctx.id); track item.label) {
        <button (click)="item.action?.()" hlmDropdownMenuItem>
          <ng-icon [name]="item.icon" hlm size="sm" />
          {{ item.label }}
        </button>
      }
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
